<ng-container *ngIf="vm$ | async as vm">
  <div class="pto-main-container" [ngClass]="{'is-loading':vm.loading}">
    <div class="pto-header-container">
      <span class="pto-header-title">{{'projects_overview_main_title' | translate}}</span>
    </div>
    <div class="spinner-border text-primary summary-question-spinner" role="status" *ngIf="vm.loading"></div>
    <div class="pto-body-container" *ngIf="!vm.loading">
      <app-highlights-and-trends *ngIf="false"></app-highlights-and-trends>
      <app-project-health *ngIf="!vm.loadingAggregateValues"
        [aggregateValues]="vm.aggregateValues"
        [projectTypes]="vm.projectTypes"
        [filterType]="projectTypeFilter"
        (changeProjectType)="changeProjectType($event)">
      </app-project-health>
      <div *ngIf="vm.loadingAggregateValues" class="loading-health-data">
        <div class="spinner-border text-primary summary-question-spinner" role="status"></div>
      </div>
      <app-project-cards *ngIf="!vm.loadingProjects"
        [projectCards]="vm.projects"
        [projectDefaultCategories]="vm.projectDefaultCategories"
        [sortByFilter]="projectSortFilter"
        [filterByIndicator]="projectIndicatorFilter"
        [quickActionData]="vm.quickMenuData"
        (emitPauseOrResumeProject)="openPauseOrResumeProjectModal($event)"
        (sortByChange)="changeProjectSort($event)"
        (indicatorSortEvent)="changeProjectIndicatorSort($event)"
        (emitGoToDashboard)="goToProjectDashboard($event)"
        (loadQuickActionMenuData)="loadQuickActionsMenuData($event)">
      </app-project-cards>
      <div *ngIf="vm.loadingProjects" class="loading-card-projects">
        <div class="spinner-border text-primary summary-question-spinner" role="status"></div>
      </div>
    </div>
  </div>
</ng-container>
